import { UUID } from '@avantstay/arriere-clients/dist/arriereBackoffice';
import { Defined } from '@avantstay/graphql-ts-client';



import { SearchCaseRowProps } from '@new/domains/operations/screens/CasesV2/CasesV2.types';
import { findCaseBooking } from '@new/domains/operations/screens/CasesV2/service/cases';


export type CaseBookingAPI = Defined<Awaited<ReturnType<typeof findCaseBooking>>>['booking']
export interface CaseBookingProps extends Defined<CaseBookingAPI> {
  workOrderId: UUID
}

export enum CaseTabs {
  cleans = 0,
  inspections = 1,
  fieldOps = 2,
}

export interface HomeCasesProps {
  cleans: SearchCaseRowProps[]
  fieldOps: SearchCaseRowProps[]
  inspections: SearchCaseRowProps[]
}

export enum CaseTypes {
  cleans = 'HOUSEKEEPING',
  fieldOps = 'FIELD_OPS',
  inspections = 'INSPECTIONS',
}